import React, { useCallback } from "react";
import { socket } from "../../../lib/socketio";
import { GroupTemplate } from "../../Definitions/cl";
import { Grid, Button } from "semantic-ui-react";
import FuelPropsColumn from "../../Monitor/FuelPropsColumn";
import FuelProps from "../../Macros/FuelProps";
import Footer from "../Footer";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC, setUserArray } from "../../../actions/headerActions";
import { setUser } from "../../../actions/navActions";
import RequestAccessModal from "../../RequestAccess/RequestAccessModal";
import { FUEL_PROP_WRITE, isAuthorized } from "../../../lib/authorization";

const FuelPropertiesPSM3 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [gasSampleOK, setGasSampleOK] = React.useState(1);
  const [dataCopy, setDataCopy] = React.useState();
  const [isCopied, setIsCopied] = React.useState(false);
  const [lpgoverrides, setlpgoverrides] = React.useState({});
  const [ngoverrides, setngoverrides] = React.useState({});
  const [fuelfactoverrides, setfuelfactoverrides] = React.useState({});
  const [ids, setIds] = React.useState(0);
  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  // update testCode
  // const [newData, setNewData] = React.useState({});

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    socket.emit("get tag names", [{ display_id: 242 }, { display_id: 129 }]);
    socket.on("receive tag names", (data) => {
      settags(data.tags_data);
      setIds(data.tags_data.map((t) => t.id));
    });
    setIsCopied(false);
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const FooterTags = tags.flatMap((t) => (t.display_id === 129 ? [t] : []));
  const GenTags = tags.flatMap((t) => (t.display_id === 242 ? [t] : []));
  const display = GenTags.map((t) => t.page_name);
  const GroupTags = GroupTemplate(GenTags, "tag_display_subgroup");

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  var testData = {};

  // update testCode
  // React.useEffect(()=> {
  //     var idsArr = Object.values(ids);
  //     idsArr.map(c => testData[c] = data[c])
  //     // setNewData(newData);
  //     setNewData(testData);
  // },[data]);

  React.useEffect(() => {
    if (Object.keys(data).length > 0) {
      socket.emit("button click", {
        buttonClickType: "Activate Fuel Properties Init PSM3",
      });
      socket.on("receive init gas_sample_ok", (value) => {
        setGasSampleOK(value.result.GAS_SAMPLE_OK);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [data]);

  React.useEffect(() => {
    if (Object.keys(data).length !== 0 && !isCopied) {
      setDataCopy({ ...data });
      setIsCopied(true);
    }
  }, [data]);

  const parentcallback1 = useCallback((flag) => {
    if (flag === true) {
      settags([...tags]);
      setngoverrides([]);
    }
  }, []);

  const parentcallback2 = useCallback((flag) => {
    if (flag === true) {
      settags([...tags]);
      setlpgoverrides([]);
    }
  }, []);

  const parentcallback3 = useCallback((flag) => {
    if (flag === true) {
      settags([...tags]);
      setfuelfactoverrides([]);
    }
  }, []);

  const fptags = [];
  let rows;
  const length = GroupTags[0].length;
  rows = Math.round(length / 4);
  let i = 0;
  while (i < length) {
    fptags.push(GroupTags[0].slice(i, i + rows));
    i += rows;
  }

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>{display[0]}</h1>
      {(electronApp || isAuthorized(user.hmi_role, FUEL_PROP_WRITE)) && (
        <Button.Group color="blue">
          <FuelProps
            tags={fuelfactoverrides}
            channel={"Activate Fuel Factors"}
            title={"Activate Fuel Factors"}
            parentCallback={parentcallback3}
          />
          <FuelProps
            tags={ngoverrides}
            channel={"Activate NG Fuel Properties PSM3"}
            title={"Activate NG Fuel Properties PSM3"}
            parentCallback={parentcallback1}
          />
          {/* <FuelProps
                    tags = {lpgoverrides}
                    channel ={'Activate LPG Fuel Properties'}
                    title = {'Activate LPG Fuel Properties'}
                    parentCallback ={parentcallback2}
                /> */}
        </Button.Group>
      )}
      {gasSampleOK === 0 ? (
        <h2 style={styles.gassample}>
          Please Check the Fuel Properties. Gas Samples Are Not OK
        </h2>
      ) : (
        ""
      )}

      <Grid inverted divided centered columns="equal" style={styles.grid}>
        <Grid.Column style={{ maxWidth: "1700px" }}>
          <Grid inverted divided centered columns="equal" style={styles.grid}>
            {fptags.map((c, i) => (
              <FuelPropsColumn
                index={i}
                column={c}
                data={data}
                dataCopy={dataCopy}
                setDataCopy={setDataCopy}
                ngoverrides={ngoverrides}
                setngoverrides={setngoverrides}
                lpgoverrides={lpgoverrides}
                setlpgoverrides={setlpgoverrides}
                fuelfactoverrides={fuelfactoverrides}
                setfuelfactoverrides={setfuelfactoverrides}
              />
            ))}
          </Grid>
        </Grid.Column>
      </Grid>
      <Footer tags={FooterTags} data={data} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "15px",
  },
  gassample: {
    color: "red",
  },
  grid: {
    marginTop: "2px",
  },
};

export default FuelPropertiesPSM3;
